/* eslint-disable */
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Spinner,
  Grid,
  GridItem,
  Image,
 Text,
  Tag,
  Button,
  VStack,
  Input,
  Spacer,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody,ModalCloseButton, ModalFooter,useDisclosure, HStack
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNFTBalances, useWeb3Transfer } from 'react-moralis';
import Rarities from '../components/RR_nft_ranks.json'

interface NftProps {
  name: string;
  metadata: {
    image?: string;
    attributes: { trait_type: string; value: string | number }[];
  };
  address: string;
  id: string;
  type: string;
  sortField?: 'name' | 'token_id';
  sortOrder?: 'asc' | 'desc';
  onDataLoaded?: (allData: any[]) => void;
}



const Nft = ({ name, id, metadata, type, address }: NftProps) => {

  const [chosenId, setChosenId] = useState(id);
  const [receiver, setReceiver] = useState('');
  
  const [refreshKey, setRefreshKey]=useState('0');
  const { fetch, error, isFetching } = useWeb3Transfer({
    type: 'erc721',
    // eslint-disable-next-line
    receiver: receiver,
    contractAddress: address,
    tokenId: chosenId,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleReceiverChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setReceiver(event.target.value);
  };

 /* useEffect(() => {
    if (!isFetching && !error) {
      // eslint-disable-next-line
     //console.log(JSON.stringify(metadata.attributes));
    }
  }, [isFetching, error]);*/

  
  const imgClickedHandler = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();
    setChosenId(id);
    setIsModalOpen(true);
  
    const safeParseAttribute = (index: number) => {
      try {
        const attr = metadata?.attributes?.[index];
        if (!attr) return { value: 'Unknown' };
        return typeof attr === 'string' ? JSON.parse(attr) : attr;
      } catch {
        return { value: 'Invalid' };
      }
    };
  
    const hero1 = safeParseAttribute(0);
    const background1 = safeParseAttribute(1);
    const backgear1 = safeParseAttribute(2);
    const armour1 = safeParseAttribute(3);
    const headgear1 = safeParseAttribute(4);
  
    const getRarity = (val: any) => ClassRarity[val?.value] || 1;
  
    const rarity =
      getRarity(metadata?.attributes?.[0]) *
      getRarity(metadata?.attributes?.[1]) *
      getRarity(metadata?.attributes?.[2]) *
      getRarity(metadata?.attributes?.[3]) *
      getRarity(metadata?.attributes?.[4]) *
      getRarity(metadata?.attributes?.[5]) *
      getRarity(metadata?.attributes?.[6]);
  
    const stats = `
      Collection name: ${name}
      NFT Id: ${id}
      NFT type: ${type}
      Background: ${background1.value} (Rarity: ${getRarity(background1)})
      Backgear: ${backgear1.value} (Rarity: ${getRarity(backgear1)})
      Armour: ${armour1.value} (Rarity: ${getRarity(armour1)})
      Headgear: ${headgear1.value} (Rarity: ${getRarity(headgear1)})
      Hero: ${hero1.value} (Rarity: ${getRarity(hero1)})
      Total rarity: ${rarity.toFixed(4)}
      <img src="${metadata?.image?.replace('ipfs://', 'https://recklessrobots.mypinata.cloud/ipfs/')}" />
    `;
  
    // Optionally: console.log(stats); or use it in a modal body if needed
  };

   
    


  const transferNft = () => {
    fetch();
  };

  const ClassRarity: Record<string, number> = {
    "GoldenSwords"	:	0.175	,
    "Green"	:	0.175	,
    "NoScarf"	:	0.38	,
    "Amethyst"	:	0.125	,
    "Blue"	:	0.175	,
    "BlueScarf"	:	0.205	,
    "Fiery"	:	0.225	,
    "Fire"	:	0.13	,
    "Flames"	:	0.185	,
    "GlowingGold"	:	0.11	,
    "GlowingYellow"	:	0.285	,
    "Gold"	:	0.11	,
    "GoldenWings"	:	0.09	,
    "GreenScarf"	:	0.16	,
    "Grey"	:	0.16	,
    "Knight"	:	0.18	,
    "Laser"	:	0.105	,
    "LightBlue"	:	0.15	,
    "Mark2"	:	0.155	,
    "MetalWings"	:	0.14	,
    "Ninja"	:	0.11	,
    "NoGear"	:	0.23	,
    "Ocean"	:	0.13	,
    "Original"	:	0.385	,
    "Red"	:	0.165	,
    "RedScarf"	:	0.255	,
    "Violet"	:	0.155	,
    "Yellow"	:	0.16	,
    

  
  
    
    // Add more values as needed
  };
  // get the rarity value for a specific trait value
  const getRarityValue = (traitType: string, traitValue: string | number) => {
    if (!metadata?.attributes || metadata.attributes.length === 0) {
      return 1; // default value when no attributes are present
    }
  
    const attribute = metadata.attributes.find((attr) => attr.trait_type === traitType);
    if (!attribute || attribute.value === undefined) {
      return 1; // default value when the attribute is not present or has no value
    }
  
  
  }

  // create a copy of the metadata object and add rarity values to the attributes
  const metadataWithRarity = { ...metadata };
  if (metadata?.attributes) {
    metadataWithRarity.attributes = metadata.attributes.map((attribute) => ({
      ...attribute,
      rarity: getRarityValue(attribute.trait_type, attribute.value),
    }));
  }

  const traitValues: { [key: string]: number } = {};
if (metadata?.attributes) {
  for (const attribute of metadata.attributes) {
    traitValues[attribute.trait_type] = attribute.value as number || 1;

  }
} else {
  metadata.attributes =  [];



  }
   
  


const rarityValues = metadata?.attributes
?.map((attr) => ClassRarity[attr.value])
.filter((rarity) => !isNaN(rarity)) || [0,45];

const totalRarity = rarityValues.reduce((a, b) => a * b, 1);



 

  return (
    <>


    <Modal  isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
    <ModalOverlay  />
    <ModalContent textColor={'black'} className='nft-cards' borderWidth={'5px'}   >
    <ModalHeader  >NFT Details</ModalHeader>
    <ModalCloseButton />
    <ModalBody textColor={'black'}>
          {metadata?.image && (
            <Image width={'50vw'} height='auto' borderRadius={'10px'}
              onClick={imgClickedHandler}
              src={metadata?.image.replace('ipfs://', 'https://ipfs.io/ipfs/')}
            />)}
           {name && id && (
          <Box   p={1}>
               <VStack textAlign={'center'}>
          <Box  >
            <Tag  padding={2} colorScheme={'white'} fontSize={'1.5vmin'}>
              {name} #{id} 
            </Tag>
     
     <HStack justifyContent={'center'}>
            <Tag  padding={2}colorScheme={'white'} fontSize={'1.5vmin'}>
            RANK: 
            </Tag> 
            {Rarities && Rarities[0]?.rank && (
  <Tag padding={2} colorScheme={'white'} fontSize={'1.5vmin'}>
    {String(JSON.stringify(Rarities[(Number(id)) - 1]?.rank))}
  </Tag>
)} </HStack>
          
           
          
          
            
          </Box>   
              <Text fontSize={'1.5vmin'}>
              {metadata?.attributes?.[0]?.trait_type  ?? ''}  {metadata?.attributes?.[0]?.trait_type ? ':':""}    {metadata?.attributes?.[0]?.value ?? ''} 
    </Text>
    
    <Text fontSize={'1.5vmin'}>
    {metadata?.attributes?.[1]?.trait_type ?? ''}  {metadata?.attributes?.[1]?.trait_type ? ':':""}          {metadata?.attributes?.[1]?.value ?? ''} 
    
    </Text>
    <Text fontSize={'1.5vmin'}>
    {metadata?.attributes?.[2]?.trait_type ?? ''}    {metadata?.attributes?.[2]?.trait_type ? ':':""}         {metadata?.attributes?.[2]?.value ?? ''} 
    
    </Text>
    <Text alignContent={'center'} fontSize={'1.5vmin'}>
    {metadata?.attributes?.[3]?.trait_type ?? ''}    {metadata?.attributes?.[3]?.trait_type ? ':':""}   {metadata?.attributes?.[3]?.value ?? ''} 
    
    </Text>
    <Text fontSize={'1.5vmin'}>
    {metadata?.attributes?.[4]?.trait_type ?? ''}  {metadata?.attributes?.[4]?.trait_type ? ':':""}    {metadata?.attributes?.[4]?.value ?? ''} 
    
    </Text>
    <Text fontSize={'1.5vmin'}>
    {metadata?.attributes?.[5]?.trait_type ?? ''}  {metadata?.attributes?.[5]?.trait_type ? ':':""}    {metadata?.attributes?.[5]?.value ?? ''}
    
    </Text>
    <Text fontSize={'1.5vmin'}>
      {metadata?.attributes?.[6]?.trait_type ?? ''}  {metadata?.attributes?.[6]?.trait_type ? ':':""}    {metadata?.attributes?.[6]?.value ?? ''}
    </Text>
    <HStack justifyContent={'space-evenly'}>
      <Button className='nft-button' size='md'colorScheme="orangered" onClick={transferNft} fontSize="1.5vmin">
              SEND
            </Button>
            <Input fontSize={'1.5vmin'} placeholder="Receiver address" value={receiver} onChange={handleReceiverChange}></Input></HStack></VStack>
      </Box>)}
    </ModalBody>
    </ModalContent>
    </Modal>
       <Box  onClick={imgClickedHandler} backgroundColor="black" borderRadius="8px" overflow="hidden"> 
       {metadata.image ? (
  <Image
  src={metadata?.image.replace('ipfs://','https://ipfs.io/ipfs/').replace('https://bhfiles.mypinata.cloud/ipfs/', 'https://ipfs.io/ipfs/')}
  loading="lazy"
width="50vmax"
    height="auto"
    borderRadius="10px"
    onError={(e) => {
      const target = e.target as HTMLImageElement;
      target.onerror = null;
      target.style.display = 'none';
      const fallback = document.createElement('div');
      fallback.className = 'nft-fallback';
      fallback.textContent = '?';
      target.parentElement?.appendChild(fallback);
    }}
  />
) : (
  <Box className="nft-fallback">?</Box>
)}
            <VStack
  textAlign="center"
  spacing={2}
  justifyContent="space-between"
  height="100%"
>
  <Box>
    <Tag className="nft-tag" padding={2} colorScheme="white" fontSize="1.5vmin">
      {name} #{id}
    </Tag>
    {Rarities && Rarities[0]?.rank && (
      <Tag padding={2} colorScheme="white" fontSize="1.5vmin">
        RANK: {String(Rarities[(Number(id)) - 1]?.rank)}
      </Tag>
    )}
  </Box>

  <Spacer />

  <Button
    textShadow="2px 0px 1px red"
    className="nft-button"
    fontSize="1.5vmin"
    width="80%"
    color= 'yellow'
    bg={'blackAlpha.500'}
  
  >
    INFO & TRANSFER
  </Button>
</VStack>

        </Box>
        </>
  );}
  
          
      

interface NftGridProps {
  token_addresses?: string[] | undefined;
  address: string;
  chain: string;
  total?: boolean;
  refreshKey?:string;
  setRefreshKey?:string;
  value:string;
  sortField?: 'name' | 'token_id';
sortOrder?: 'asc' | 'desc';
onDataLoaded?: (allData: any[]) => void;
}


export const NftGrid = ({ address, refreshKey, setRefreshKey, value, sortOrder, sortField, onDataLoaded }: NftGridProps) => {

   
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(12); // Change to 9, 16, etc. if you want

 
 

 
  const { data, error, isLoading } = useNFTBalances(
    {
      //@ts-ignore
     // tokenAddresses: [value],
      chain: '0x19',
      address,
    },
    {
      autoFetch: true,
    }

    
    
  );

  useEffect(() => {
    if (data?.result && onDataLoaded) {
      onDataLoaded(data.result);
    }

  }, [data, onDataLoaded]);
  const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;const filteredData = data?.result?.filter((nft) => nft.token_address === value);
const sortedData = filteredData?.slice().sort((a, b) => {
  const valA = sortField === 'token_id' ? parseInt(a.token_id) : a.name?.toLowerCase() || '';
  const valB = sortField === 'token_id' ? parseInt(b.token_id) : b.name?.toLowerCase() || '';
  if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
  if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
  return 0;
});



const paginatedData = sortedData?.slice(startIndex, endIndex);


  if (isLoading) {
    return (
      <Box>
        <Spinner thickness="4px" color="blue.300" size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>{error.name}</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
       
      </Box>
    );
  }

  if (!data?.result || data.result.length === 0) {
    return (
      <Box>
        <Alert status="info">
          <AlertIcon />
          <AlertTitle>No results</AlertTitle>
          <AlertDescription>
            There are no NFTs associated with this address.
          </AlertDescription>
        </Alert>
      </Box>
    );
  }

  
  return (
    <VStack alignItems="start">
      


      
      <Grid className='nft-grid' templateColumns="repeat(auto-fit, minmax(200px, 1fr))" gap={6}>
      {paginatedData?.map((nft: any) => (
                  <GridItem   className='fire' key={`${nft.token_address}${nft.token_id}`}>
            <Nft
              name={nft.name}
              id={nft.token_id}
              address={nft.token_address}
              metadata={nft.metadata}
              type={nft.contract_type}
  
            />
        
          </GridItem>
        ))}
      </Grid>
      <HStack spacing={4} mt={6} justify="center">
  <Button className='nft-button'onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} isDisabled={currentPage === 1}>
    Previous
  </Button>
  <Text>Page {currentPage}</Text>
  <Button
    onClick={() => setCurrentPage(p => p + 1)}
    isDisabled={endIndex >= data.result.length}
  >
    Next
  </Button>
</HStack>
    </VStack>
  );

};

export default NftGrid;